define('app-FindByProductCode/settings',[],function () {
    return {
        container: '.findByProductCode',
        link: '#lnkFindByProductCode',
        productSearchUrl: window.location.protocol + '//' + window.location.host + '/FindByProductCode/Get'
    };
});
